import { useEffect, useState } from "react";
import { Feature } from "../redux/services/config";
import placeholderDark from "../components/Map/components/SearchResultsCarousel/components/SearchResultsCarouselItem/img/placeholder_dark.png";
import placeholderLight from "../components/Map/components/SearchResultsCarousel/components/SearchResultsCarouselItem/img/placeholder_light.png";

// Use the browser HTTP cache without requiring cross-origin fetch permission.
const preloadImage = (src: string) =>
  new Promise<void>((resolve) => {
    const image = new Image();
    const finish = () => {
      clearTimeout(timeout);
      image.onload = null;
      image.onerror = null;
      image.onabort = null;
      resolve();
    };
    const timeout = setTimeout(finish, 10000);
    image.onload = finish;
    image.onerror = finish;
    image.onabort = finish;
    image.src = src;
  });

export const useImagePreloader = (
  features: Feature[] | undefined,
  enable: boolean,
) => {
  const [imagesPreloaded, setImagesPreloaded] = useState(false);
  useEffect(() => {
    if (!enable || !features) return;
    let active = true;
    const sources = Array.from(
      new Set([
        placeholderDark,
        placeholderLight,
        ...features
          .map((feature) => feature.properties.popup_image_url)
          .filter((url): url is string => !!url),
      ]),
    );
    let index = 0;
    const worker = async () => {
      while (active && index < sources.length) {
        const src = sources[index++];
        await preloadImage(src);
      }
    };
    Promise.all(Array.from({ length: 8 }, worker)).then(() => {
      if (active) setImagesPreloaded(true);
    });
    return () => {
      active = false;
    };
  }, [features, enable]);
  return { imagesPreloaded };
};
